import { LocationSchema } from 'model';
import { isValidPhoneNumber } from 'react-phone-number-input';
import { config } from 'utils/config';
import { z } from 'zod';
import { ContactBasicInfoFields } from './ContactBasicInfo.types';

export const PHONE_NUMBER_DEFAULT_COUNTRY = 'ES';

export const AVATAR_MAX_SIZE_IN_BYTES =
  parseInt(config.maxMediaSizeInKb, 10) * 1024;

export const ContactBasicInfoFieldsSchema = z.object({
  avatar: z.any().optional().nullable(),
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  whereDoYouLive: LocationSchema.optional().nullable(),
  phoneNumber: z
    .string()
    .optional()
    .refine((phoneNumber) => {
      return phoneNumber ? isValidPhoneNumber(phoneNumber) : true;
    }, 'portal-manfredite:portal-manfredite.messages.error.invalid-phone')
});

export const FORM_DEFAULT_VALUES: ContactBasicInfoFields = {
  firstName: '',
  lastName: '',
  phoneNumber: '',
  whereDoYouLive: null
};
